<script lang="ts">
    import { onMount } from "svelte";
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faDice } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let tid = ""
    let sid = ""
    let gid = "";
    let device = 'desktop'
    export let params = {};
    let textLoad = 'Loading...'
    onMount(() => {
        getGameURL('UFA')
	});
    async function getGameURL(mgds) {
        Swal.fire({
            title: 'กรุณารอสักครู่',
            html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
            timer: 5000,
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
            willClose: () => {
                
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                
            }
        })

        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:""
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            transferCash(json.txid,json.payload)
        } else {
            if(json.statusCode==205){
                Swal.fire({
                    title: "ไม่สามารถเล่นเกมได้",
                    text: json.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ยกเลิกโปรโมชั่น",
                    cancelButtonText: "ปิด"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        clearpromotion()
                    }
                });
            }else{
                Swal.fire(json.message)
            }
            throw new Error(json);
        }

    }
    async function clearpromotion() {
        // loaDing =false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/clearpromotion", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire(json.message)
            push('/dashboard')
		} else {
            Swal.fire(json.message)
            push('/dashboard')
            throw new Error(json);
		}
    }
    async function transferCash(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = url
            window.location=url 
		} else {

            throw new Error(json);
		}
    }
    
</script>
<div class="default-home">
<div class="row  mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 class="header-n">Start Game</h4></div>
    <div class="col-12 " style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-5 border p-5 rounded border-warning" style="">
            <Fa icon={faDice} size="10x" pulse class="text-white"/><br />
            <span class="text-white">{textLoad}</span>
        </div>
        {/if}
        {#if !loading}

        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-starts">
        <HeaderThemes/>
        <div class="col-12 text-center mt-5" ><h4 class="head-title">Start Game</h4></div>
        <div class="col-12 " style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-5 border p-5 rounded border-warning" style="">
                <Fa icon={faDice} size="10x" pulse class="text-white"/><br />
                <span class="text-white">{textLoad}</span>
            </div>
            {/if}
            {#if !loading}

            {/if}
        </div>
    </div>
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>